import gsap from 'gsap'

export function introAnimation() {
  let timeline2 = new gsap.timeline({ repeat: -1 , paused: true })
 
  timeline2
    .to('#learnmore', {
      duration: 2,
      y: -20,
      ease: "power1.out",
    })
    .to('#learnmore', {
      duration: 2,
      y: 0,
      ease: "power1.out",
    })
    .to('#arrow', {
      duration: 2,
      y: -35,
      ease: "power1.out",
    }, "-=4")
    .to('#arrow', {
      duration: 2,
      y: 0,
      ease: "power1.out",
    }, "-=2");

  let timeline1 = new gsap.timeline({ 
    repeat: 0 , 
    paused: false,
    onComplete: function() { 
      timeline2.paused(false);
    }
  });
 
  timeline1
     .to('#learnmore', {
       duration: 2,
       autoAlpha: 1,
     }, "+=7")
     .to('#arrow', {
        duration: 2,
        autoAlpha: 1,
      }, "-=2");

}

export function scrollAnimation() {
  
}
